
import styled from 'styled-components';
   
export const Box = styled.div`
    padding: 25px;
    background: #C24728;
    position: absolute;
    margin-top: auto;
    width: 100%;
   
  @media screen and (max-width: 768px) {
    padding: 30px 30px;
  }
`;
  
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 1000px;
    margin: 0 auto;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-left: 60px;

  @media (max-width: 1000px) {
    margin-left: 30px;
    margin-right: 30px;
  }
`;
   
export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(273px,1fr));
  grid-gap: 88px;
   
  @media (max-width: 1000px) {
    grid-gap: 23px;
    grid-template-columns: repeat(auto-fill, 
                           minmax(200px, 1fr));
  }
`;

export const FooterLink = styled.a`
  color: #fff;
  margin-bottom: 20px;
  font-size: 15px;
  text-decoration: none;
  margin-right: 5px;

   
  &:hover {
      color: #F9BE84;
      transition: 200ms ease-in;
  }
`;

export const FooterText = styled.p`
    color: #fff;
    font-size: 15px;

}
`
   
export const Heading = styled.p`
  font-size: 18px;
  color: #fff;
  font-weight: bold;
`;

export const SubRow = styled.div`
    padding-top: 10%;
`

export const SubColumn = styled.div`
    width: 25px;
    display: inline-table;
    margin-right: 2%;
`;